"use client";

import { useState, useEffect } from "react";
import { Button, Modal } from "antd";
import { Download } from "lucide-react";

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);

      // Check if user has dismissed the prompt recently
      const dismissedTime = localStorage.getItem("pwa-prompt-dismissed");
      if (dismissedTime) {
        const daysSinceDismissed = (Date.now() - parseInt(dismissedTime)) / (1000 * 60 * 60 * 24);
        if (daysSinceDismissed < 7) {
          return; // Don't show again for 7 days
        }
      }

      setShowPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    await deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {

    }

    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    // Store dismissal in localStorage to not show again for some time
    localStorage.setItem("pwa-prompt-dismissed", Date.now().toString());
  };

  if (!showPrompt || !deferredPrompt) return null;

  return (
    <Modal
      open={showPrompt}
      onCancel={handleDismiss}
      footer={null}
      centered
      width={400}
    >
      <div className="text-center py-4">
        <Download className="w-16 h-16 mx-auto text-primary mb-4" />
        <h3 className="text-xl font-semibold mb-2">
          Cài đặt Lookme Merchant
        </h3>
        <p className="text-gray-600 mb-6">
          Cài đặt ứng dụng để truy cập nhanh hơn và sử dụng offline
        </p>
        <div className="flex gap-3 justify-center">
          <Button onClick={handleDismiss}>
            Để sau
          </Button>
          <Button type="primary" onClick={handleInstall}>
            Cài đặt ngay
          </Button>
        </div>
      </div>
    </Modal>
  );
}